<template>
	<div class="">
		<div class="row">
			<div class="col">
				<BioTestingButtons title='<i class="fas fa-home"></i> Admin Quiz Actions' />
			</div>
		</div>
	</div>
</template>

<script>
import BioTestingButtons from '../components/BioTestingButtons.vue';
export default {
	name: 'BioTestingAdminCard',
	components: {
		BioTestingButtons,
	},
	props: {},
	data() {
		return {};
	},
	mounted() {},

	computed: {},

	methods: {},

	watch: {},
};
</script>

<style scoped></style>
